import { lifecycle } from 'recompose';
import axios from 'axios';

export default () => lifecycle({
    componentDidMount() {
        axios.get('https://www.googleapis.com/blogger/v3/blogs/5702242311891926673/posts?key=AIzaSyBwdk_emu6Nutd2MyU15raITbweCmrsZuA')
            .then( result => this.props.setPosts( result.data.items ) );
    }
});